/* eslint-disable max-len */
var UI_CHEVRON_DOWN = {
  "default": 'M31.68,8.63,16.94,25.05a1.26,1.26,0,0,1-1.88,0L.32,8.63h0A1.26,1.26,0,0,1,2.2,7L16,22.32,29.8,7a1.26,1.26,0,1,1,1.88,1.68Z',
  globetrotter: 'M29.5 9.25L16 22.75L2.5 9.25'
};

export { UI_CHEVRON_DOWN };
//# sourceMappingURL=UI_CHEVRON_DOWN.js.map
